import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    meetingURL: "",
};

export const joinMeetingSlice = createSlice({
    name: "joinMeetingSlice",
    initialState,
    reducers:{
        setMeetingURL: (state, action) => {
            state.meetingURL = action.payload;
        },
    },
});

export const { setMeetingURL } = joinMeetingSlice.actions;
export const joinMeetingReducer = joinMeetingSlice.reducer;


